export enum PATH {
    HOME = '/',
    SERVICES = '/servicii',
    CONTACT = '/contact'
}